import { defineStore } from 'pinia'
import axios from 'axios'
import store from '../store'

export const useStoryLocationsStore = defineStore('storyLocations', {
  state: () => ({
    storyLocations: [],
    fetchInitiated: false
  }),

  getters: {
    locationIds({ storyLocations }) {
      return storyLocations.map(({ location: { id } }) => id)
    }
  },

  actions: {
    async fetch({ storyId }) {
      this.fetchInitiated = true

      return axios.get(`/api/internal/stories/${storyId}/story_locations`)
        .then(response => {
          this.storyLocations = response.data.story_locations
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    },

    async create({ storyId, locationId }) {
      return axios.post(`/api/internal/stories/${storyId}/story_locations`, { location_id: locationId })
        .then(response => {
          this.storyLocations.push(response.data.story_location)
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async destroy({ storyId, storyLocationId }) {
      return axios.delete(`/api/internal/stories/${storyId}/story_locations/${storyLocationId}`)
        .then(() => {
          this.storyLocations = this.storyLocations.filter((storyLocation) => storyLocation.id !== storyLocationId)
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    }
  }
})
